export default __webpack_public_path__ + "static/media/operationModes.22acfe9c.svg";